var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3731_19421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.995 20.2958L37.4957 30.3439H2.50426L0.00488281 20.2958L18.8413 6.16848C19.5279 5.65348 20.472 5.65348 21.1586 6.16848L39.995 20.2958Z",
    fill: "#FFCA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.498 36.6042H7.50293V5.90137C7.50293 5.59934 7.74777 5.35449 8.0498 5.35449H27.498V36.6042Z",
    fill: "#9AE69C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9974 36.5946H10.0024V3.42383C10.0024 3.1218 10.2473 2.87695 10.5493 2.87695H29.9975V36.5946H29.9974Z",
    fill: "#6FD6A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2473 36.5949H12.502V0.902344C12.502 0.600313 12.7468 0.355469 13.0488 0.355469H30.7005C31.0025 0.355469 31.2473 0.600313 31.2473 0.902344V36.5949Z",
    fill: "#9AE69C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9501 0.355469H29.4507C29.7527 0.355469 29.9976 0.600313 29.9976 0.902344V36.5949H32.4969V0.902344C32.4969 0.600313 32.2521 0.355469 31.9501 0.355469Z",
    fill: "#6FD6A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5833 35.3465H17.4149C17.4149 34.0133 16.3341 32.9326 15.001 32.9326V6.4034V5.76449C15.001 5.50418 15.1836 5.27566 15.4396 5.22863C15.7142 5.17824 15.9725 5.08137 16.2061 4.94652C16.6066 4.71535 16.9345 4.37246 17.1472 3.96051C17.2516 3.7584 17.3282 3.53973 17.3721 3.30941C17.4221 3.04762 17.6445 2.85449 17.911 2.85449C18.4404 2.85449 27.2102 2.85449 27.0875 2.85449C27.3499 2.85449 27.5762 3.04074 27.6242 3.29863C27.8037 4.26387 28.5654 5.0452 29.5561 5.22816C29.813 5.27559 29.9974 5.50309 29.9974 5.76434V6.75527V32.9325C28.6641 32.9326 27.5833 34.0133 27.5833 35.3465Z",
    fill: "#BBEFBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4352 10.3398C21.7451 10.3398 21.1855 9.78027 21.1855 9.09012V6.60418C21.1855 5.91402 21.7451 5.35449 22.4352 5.35449C23.1254 5.35449 23.6849 5.91402 23.6849 6.60418V9.09012C23.6849 9.78027 23.1255 10.3398 22.4352 10.3398Z",
    fill: "#9AE69C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.489 22.8393C25.2441 22.8393 27.4775 20.6059 27.4775 17.8508C27.4775 15.0957 25.2441 12.8623 22.489 12.8623C19.7339 12.8623 17.5005 15.0957 17.5005 17.8508C17.5005 20.6059 19.7339 22.8393 22.489 22.8393Z",
    fill: "#9AE69C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9975 3.45801C30.3297 3.45801 30.601 3.18801 30.601 2.85449C30.601 2.51965 30.3271 2.25098 29.9974 2.25098C29.6736 2.25098 29.394 2.51371 29.394 2.85449C29.394 3.19168 29.6683 3.45801 29.9975 3.45801Z",
    fill: "#F0FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0014 3.45836C15.3439 3.45836 15.6049 3.17813 15.6049 2.85484C15.6049 2.54367 15.3574 2.25195 14.9987 2.25195C14.668 2.25195 14.3979 2.52258 14.3979 2.85484C14.3979 3.19016 14.6685 3.45836 15.0014 3.45836Z",
    fill: "#F0FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0482 17.2214H24.9806C24.5857 16.1707 23.1448 15.933 22.5117 16.7406C21.8178 17.6252 22.0178 18.4494 21.4293 18.3501C21.2634 18.3222 20.982 18.1793 20.9796 17.8209C20.9771 17.4395 20.9912 17.3493 21.1728 17.0718C21.3682 16.7731 21.2647 16.3654 20.936 16.2005C20.6574 16.0607 20.3171 16.1714 20.1482 16.4333C19.9555 16.7321 19.8581 16.972 19.8114 17.2329C19.1214 17.3695 19.1891 18.387 19.8942 18.4273C20.45 19.8788 22.4705 19.9886 23.0052 18.4762C23.1278 18.1293 23.2904 17.7032 23.4609 17.486C23.5214 17.4279 23.7996 17.4743 23.8557 17.6608C23.924 17.8876 23.8932 18.1337 23.7365 18.3013C23.5078 18.5459 23.5217 18.9302 23.7678 19.1573C24.1567 19.516 24.7579 19.287 25.0161 18.4284H25.0482C25.3816 18.4284 25.6518 18.1582 25.6518 17.8249C25.6518 17.4915 25.3816 17.2214 25.0482 17.2214Z",
    fill: "#F0FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.7041V20.3408L13.8361 27.327L8.22711 33.3632L0 37.7041Z",
    fill: "#FCDF65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 37.7041V20.3408L26.1641 27.327L32.226 33.9494L40.0002 37.7041Z",
    fill: "#FCDF65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4609 27.6821L20 30.4395L39.7804 40.2323C39.9137 40.1325 40 39.9734 40 39.7941V37.7043L26.1639 27.3271L25.4609 27.6821Z",
    fill: "#FFCA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.219609 40.2322L20 30.4395L13.8361 27.3271L0 37.7043V39.7941C0 39.9734 0.08625 40.1325 0.219609 40.2322Z",
    fill: "#FFCA2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1592 26.2106C20.4697 25.6935 19.5255 25.6974 18.8413 26.2106C17.9233 26.8992 0.875879 39.6846 0.184082 40.2035C0.280645 40.2893 0.407754 40.3414 0.547051 40.3414H39.4533C39.5926 40.3414 39.7197 40.2893 39.8163 40.2035C39.123 39.6835 22.0753 26.8978 21.1592 26.2106Z",
    fill: "#FCDF65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3731_19421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.348633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourly);
export default __webpack_public_path__ + "static/media/hourly.c5b97c9284f37e20a57248634d61016a.svg";
export { ForwardRef as ReactComponent };